module.exports = __webpack_public_path__ + "img/x-close.a390073d.svg";